import { Component, ChangeDetectionStrategy, input, signal } from '@angular/core';
import { MaisSource } from '../../../services/chat-mais.service';

let nextInstanceId = 0;

@Component({
  selector: 'app-ai-sources-card',
  templateUrl: './ai-sources-card.component.html',
  styleUrls: ['./ai-sources-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AiSourcesCardComponent {
  sources = input<MaisSource[]>([], { alias: 'sources' });

  expanded = signal(false);

  // Unique per instance so aria-controls/id don't collide when several AI replies with sources
  // are rendered in the same message list.
  readonly listId = `ai-sources-list-${nextInstanceId++}`;

  toggle(): void {
    this.expanded.update(value => !value);
  }

  matchPercent(source: MaisSource): number | null {
    return typeof source.score === 'number' ? Math.round(source.score * 100) : null;
  }

  excerptFor(source: MaisSource): string {
    const raw = source.text ?? source.chunk ?? '';
    // Real KB chunks embed their own title as a heading at the top of the text (confirmed
    // against a live capture, e.g. "Ottawa Airport Travel Guide\n\nOttawa Macdonald-Cartier...")
    // - shown as-is it duplicates the bold title line right above it, so strip that leading
    // repeat before truncating.
    if (source.title && raw.startsWith(source.title)) {
      return raw.slice(source.title.length).replace(/^\s+/, '');
    }
    return raw;
  }
}
